module.exports = __webpack_public_path__ + "static/media/rmt-back.a2719c69.jpg";